import { Link } from 'react-router-dom';
import { articleLinks } from '@/mocks/trustSignals';

const iconMap: Record<number, string> = {
  0: 'ri-book-open-line',
  1: 'ri-rocket-line',
  2: 'ri-scales-3-line',
  3: 'ri-settings-3-line',
  4: 'ri-folder-chart-line',
  5: 'ri-money-dollar-circle-line',
  6: 'ri-map-pin-line',
  7: 'ri-global-line',
  8: 'ri-file-copy-line',
  9: 'ri-cpu-line',
  10: 'ri-award-line',
  11: 'ri-question-answer-line',
};

export default function ArticlesSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Mulebuy Spreadsheet Guides
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-4 max-w-2xl mx-auto">
            In-depth articles to help you master the Mulebuy spreadsheet system — from setup to advanced sourcing strategies. {articleLinks.length} comprehensive guides available.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {articleLinks.map((article, idx) => (
            <Link
              key={article.path}
              to={article.path}
              onClick={() => window.scrollTo(0, 0)}
              className="group bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-300 transition-all cursor-pointer flex flex-col"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors flex-shrink-0">
                <i className={`text-xl text-primary-600 ${iconMap[idx] || 'ri-file-text-line'}`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors leading-snug">
                {article.title}
              </h3>
              <p className="text-foreground-500 text-xs mt-2 leading-relaxed flex-1">
                {article.description}
              </p>
              <span className="inline-flex items-center gap-1.5 mt-4 text-xs font-semibold text-primary-600 group-hover:text-primary-700 whitespace-nowrap">
                Read Article
                <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-0.5"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}